// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === "src_themes_reactwp_js_templates_Home_jsx") return "reactwp/assets/css/chunks/" + chunkId + ".css";
	// return url for filenames based on template
	return undefined;
};